import type { WishItem } from "../../models/contracts";
import { WishCard } from "./WishCard";

export const SpotlightWishRenderer = ({ wishes, focusId, arrivalId }: { wishes: WishItem[]; focusId: string | null; arrivalId: string | null }) => {
  const featured = wishes.find(wish => wish.id === arrivalId) ?? wishes.find(wish => wish.id === focusId) ?? wishes[0];
  if (!featured) return null;
  const supporting = wishes.filter(wish => wish.id !== featured.id).slice(0, 4);
  return <div class="wish-layout wish-layout-spotlight">
    <WishCard wish={featured} index={0} featured focusId={focusId} />
    <div class="wish-supporting">{supporting.map((wish, index) => <WishCard key={wish.id} wish={wish} index={index + 1} focusId={focusId} />)}</div>
  </div>;
};
